
import { Game } from "@/models/Game";
import { JigsawPuzzleData } from "@/models/MapPois/Quest/Puzzle";
import ImageBox from "@/components/Base/ImageBox.vue";
import ImageSelector from "@/components/Base/ImageSelector.vue";
import { Quest_CG_MinigameSection } from "@/models/MapPois/Quest/QuestMapPoi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { minValue, required } from "vuelidate/lib/validators";

@Component({
  components: { ImageBox, ImageSelector },
})
class Jigsaw extends Vue {
  @Prop({ default: null }) readonly getContentData!: Quest_CG_MinigameSection;
  @Prop({ default: true }) readonly difficultyLevel!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  @Prop({ default: null }) readonly gameData!: Game;
  target = "";
  showImageTargetSelectorBool = false;
  cells = 8;
  helper = false;

  get getAudioPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/audio/poi/"
    );
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/puzzle/"
    );
  }

  created(): void {
    this.getDefaultJigsawPuzzleData();
  }

  showTargetSelector(): void {
    if (!this.isEditingLocked) {
      this.showImageTargetSelectorBool = true;
    }
  }
  handleCloseButtonPress(): void {
    this.showImageTargetSelectorBool = false;
  }

  returnImageTargetPath(path: string): void {
    this.showImageTargetSelectorBool = false;
    this.target = this.getImagePath + "" + path;
    this.setDefaultJigsawPuzzleData();
  }

  clearTargetImage(): void {
    if (!this.isEditingLocked) {
      this.target = "";
      var data = this.getJigsawPuzzleDifficulty();
      data.imgs = this.target;
      this.$emit("updateData", this.getContentData.puzzle.puzzleData);
    }
  }

  getJigsawPuzzleDifficulty(): JigsawPuzzleData {
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy === undefined) {
        this.getContentData!.puzzle.puzzleData.easy = this.setJigsawPuzzleData();
        this.getContentData!.puzzle.puzzleData.easy.onFail = this.getContentData.puzzle.puzzleData.easy.onFail;
        this.getContentData!.puzzle.puzzleData.easy.onSuccess = this.getContentData.puzzle.puzzleData.easy.onSuccess;
        this.getContentData!.puzzle.puzzleData.easy.onIncorrect = this.getContentData.puzzle.puzzleData.easy.onIncorrect;
      }
      return this.getContentData?.puzzle.puzzleData.easy as JigsawPuzzleData;
    } else if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard === undefined) {
        this.getContentData!.puzzle.puzzleData.hard = this.setJigsawPuzzleData();
        this.getContentData!.puzzle.puzzleData.hard.onFail = this.getContentData.puzzle.puzzleData.hard.onFail;
        this.getContentData!.puzzle.puzzleData.hard.onSuccess = this.getContentData.puzzle.puzzleData.hard.onSuccess;
        this.getContentData!.puzzle.puzzleData.hard.onIncorrect = this.getContentData.puzzle.puzzleData.hard.onIncorrect;
      }
      return this.getContentData?.puzzle.puzzleData.hard as JigsawPuzzleData;
    } else {
      if (this.getContentData?.puzzle.puzzleData.default === undefined) {
        this.getContentData!.puzzle.puzzleData.default = this.setJigsawPuzzleData();
      }
      return this.getContentData!.puzzle.puzzleData.default as JigsawPuzzleData;
    }
  }
  getDefaultJigsawPuzzleData(): void {
    var data = this.getJigsawPuzzleDifficulty();
    this.target = data.imgs;
    this.cells = Number(data.cells);
    this.helper = data.helper;
  }
  setDefaultJigsawPuzzleData(): void {
    var data = this.getJigsawPuzzleDifficulty();
    data.imgs = this.target;
    data.cells = Number(this.cells);
    data.helper = this.helper;
    this.$emit("updateData", this.getContentData.puzzle.puzzleData);
  }
  setJigsawPuzzleData(): JigsawPuzzleData {
    return {
      imgs: "",
      cells: 8,
      helper: false,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  @Watch("getContentData")
  getContentDataWatch(): void {
    this.getDefaultJigsawPuzzleData();
  }

  @Watch("difficultyLevel")
  getdifficultyLevelWatch(): void {
    this.getDefaultJigsawPuzzleData();
  }

  @Validations()
  validations = {
    target: {
      minLength: minValue(1),
      required,
    },
  };
}
export default Jigsaw;
